// Module
var code = `<h2 class="section-header">Remittance Upload</h2>

<form name="\$ctrl.form" novalidate>
  <table class="table table--generate-row-ids">
    <tbody>
    <tr>
      <td></td>
      <td>Payment type:</td>
      <td>
        <select name="remittanceMethod"
                class="form-control"
                ng-model="\$ctrl.batchRemittanceUploadData.remittanceMethod"
                ng-options="paymentMethod.value as paymentMethod.label for paymentMethod in \$ctrl.paymentMethods"
                ng-change="\$ctrl.paymentMethodChanged()"
                required>
        </select>
      </td>
    </tr>
    <tr>
      <td></td>
      <td>Branch of service:</td>
      <td>
        <select class="form-control"
                ng-model="\$ctrl.batchRemittanceUploadData.branchOfService"
                ng-options="bos.value as bos.label for bos in \$ctrl.branchOfService"
                required>
        </select>
      </td>
    </tr>
    <tr ng-if="['PHILIPPINE_AIR_FORCE'].includes(\$ctrl.batchRemittanceUploadData.branchOfService)">
      <td></td>
      <td>File type:</td>
      <td>
        <select class="form-control"
                ng-model="\$ctrl.batchRemittanceUploadData.fileType"
                ng-options="f.value as f.label for f in \$ctrl.fileTypes"
                required>
        </select>
      </td>
    </tr>
    <tr ng-if="\$ctrl.batchRemittanceUploadData.remittanceMethod === 'MEMO'">
      <td></td>
      <td>Loan category:</td>
      <td>
        <gl-category-select
          required
          ng-model="\$ctrl.glPaymentLoanCategory"
          action-type="'LOAN_GL_PAYMENT'"
          single-accounts-only="true"
          is-selectize="true"
          ng-change="\$ctrl.glPaymentLoanCategoryChanged()"
        >
        </gl-category-select>
        <input type="text" disabled ng-value="\$ctrl.glPaymentLoanCategory.ledgerAccountFullCodes[0]" />
      </td>
    </tr>
    <tr ng-if="\$ctrl.batchRemittanceUploadData.remittanceMethod === 'MEMO'">
      <td></td>
      <td>Term deposit category:</td>
      <td>
        <gl-category-select
          required
          ng-model="\$ctrl.glPaymentDepositCategory"
          action-type="'DEPOSIT_PLACEMENT_BY_MEMO'"
          single-accounts-only="true"
          is-selectize="true"
          ng-change="\$ctrl.glPaymentDepositCategoryChanged()"
        >
        </gl-category-select>
        <input type="text" disabled ng-value="\$ctrl.glPaymentDepositCategory.ledgerAccountFullCodes[0]" />
      </td>
    </tr>
    <tr ng-if="\$ctrl.batchRemittanceUploadData.remittanceMethod === 'MEMO'">
      <td></td>
      <td>Deposit account category:</td>
      <td>
        <gl-category-select
          required
          ng-model="\$ctrl.glPaymentAccountCategory"
          action-type="'CREDIT_ACCOUNT_BY_MEMO'"
          single-accounts-only="true"
          is-selectize="true"
          ng-change="\$ctrl.glPaymentAccountCategoryChanged()"
        >
        </gl-category-select>
        <input type="text" disabled ng-value="\$ctrl.glPaymentAccountCategory.ledgerAccountFullCodes[0]" />
      </td>
    </tr>
    <tr ng-if="\$ctrl.batchRemittanceUploadData.remittanceMethod === 'TRANSFER'">
      <td></td>
      <td>Account number:</td>
      <td>
        <input name="accountNumber"
               class="form-control"
               ng-model="\$ctrl.batchRemittanceUploadData.accountNumber"
               type="text"
               required/>
      </td>
    </tr>
    <tr>
      <td></td>
      <td>Official receipt:</td>
      <td>
        <input name="officialReceipt"
               class="form-control"
               ng-model="\$ctrl.batchRemittanceUploadData.officialReceipt"
               type="text"
               required />
      </td>
    </tr>
    <tr>
      <td></td>
      <td>Remarks:</td>
      <td>
        <input
          type="text"
          maxlength="512"
          ng-model="\$ctrl.batchRemittanceUploadData.remarks"
        />
      </td>
    </tr>
    <tr>
      <td></td>
      <td>File:</td>
      <td>
        <file-id-upload
          single-file="true"
          ng-model="\$ctrl.batchRemittanceUploadData.uploadedFileId"
          validate="{pattern: '*.xlsx,*.xls,*.dbf'}"
          enable-webcam="false"
          max-files="1"
          max-size="'50MB'"
          show-remarks="false"
          required
        >
        </file-id-upload>
      </td>
    </tr>
    <tr>
      <td></td>
      <td>Applicable Month:</td>
      <td>
        <date ng-model="\$ctrl.applicableMonthFirstDay" type="month" ng-required="true" max="\$ctrl.applicableMonthMaxDate"></date>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.resetForm()">
      Clear form
    </button>
    <button
      command-access="ProcessRemittanceFile"
      type="button"
      class="btn btn-success"
      ng-click="\$ctrl.executeBatchRemittance()"
      ng-disabled="\$ctrl.form.\$invalid">
      Submit payment
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/remittance/batch-remittance-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;